export const categories = [
  { slug: "kehuan", name: "科幻", icon: "ri-rocket-line", count: 28, description: "探索未来世界，遨游星辰大海" },
  { slug: "dongzuo", name: "动作", icon: "ri-focus-3-line", count: 45, description: "热血激战，肾上腺素飙升" },
  { slug: "xiju", name: "喜剧", icon: "ri-emotion-laugh-line", count: 63, description: "开怀大笑，欢乐不停歇" },
  { slug: "juqing", name: "剧情", icon: "ri-film-line", count: 52, description: "感人至深，直击心灵" },
  { slug: "donghua", name: "动画", icon: "ri-palette-line", count: 37, description: "奇思妙想，色彩斑斓的世界" },
  { slug: "xuanyi", name: "悬疑", icon: "ri-search-eye-line", count: 29, description: "烧脑推理，真相只有一个" },
  { slug: "oumei", name: "欧美", icon: "ri-global-line", count: 86, description: "好莱坞大片，全球热门" },
  { slug: "kongbu", name: "恐怖", icon: "ri-ghost-line", count: 19, description: "惊悚刺激，挑战胆量极限" },
  { slug: "aiqing", name: "爱情", icon: "ri-heart-line", count: 34, description: "浪漫甜蜜，心动瞬间" },
  { slug: "qihuan", name: "奇幻", icon: "ri-magic-line", count: 22, description: "魔法世界，无限想象" }
];

export const getCategoryBySlug = (slug: string) => categories.find(c => c.slug === slug);